import React from 'react'
import { MailSettingsInstance } from 'plugin-reports-maker/webapp/js/common/types/api/report'
import { ScheduleType } from '../helper/helper'
import { ScheduleDate } from './ScheduleDate'
import { ScheduleCron } from './ScheduleCron'
import { ScheduleRule } from './ScheduleRule'
import styled from 'styled-components'

export function getScheduleTypeComponent({
    scheduleType,
    settings,
    updateSettings
}: PropScheduleType): string | JSX.Element {
    if (scheduleType == null) {
        return null
    }
    switch (scheduleType) {
        case ScheduleType.Date:
            return <ScheduleDate scheduleType={scheduleType} settings={settings} updateSettings={updateSettings} />
        case ScheduleType.Recurrent:
            return <ScheduleCron scheduleType={scheduleType} settings={settings} updateSettings={updateSettings} />
        case ScheduleType.Rule:
            return <ScheduleRule scheduleType={scheduleType} settings={settings} updateSettings={updateSettings} />
        default:
            return ''
    }
}
export const ScheduleContent = styled.div`
    min-height: 200px;
    padding: 8px 0px;
`
export const ScheduleContentBox = styled.div`
    /* padding: 8px; */
    min-height: 50px;
    height: max-content;
    border-radius: 3px;

    width: 100%;
    padding: 8px 16px;
    background: var(--gray-0);
    border: 1px solid var(--gray-400);
    border-radius: 3px;
    /* height: 144px; */
`

export interface PropScheduleType {
    settings: MailSettingsInstance
    scheduleType: ScheduleType
    updateSettings: (settings: MailSettingsInstance) => void
}
